import React, { useContext } from 'react';
import _ from 'lodash';
import { FilterContextData } from 'contexts/FilterContext';
import { formatWord } from 'utils/helperMethods';
import useFilterV2Selection from 'hooks/Filter/useFilterV2Selection';
import FilterV2Chip from './FilterV2Chip';

interface Props {
    timeSelectionLabel: string;
    screenFilterConfig: any;
    setAttributeTypeExpandClose: Function;
    uppercaseFilterLabels?: boolean;
}

function FilterV2AppliedFilters({
    timeSelectionLabel,
    screenFilterConfig,
    setAttributeTypeExpandClose,
    uppercaseFilterLabels,
}: Props) {
    const { allCheckedAttribute, hideGlobalTimeFilterComponent } = useContext(FilterContextData);
    const { removeAttributeValue, clearAttributeType } = useFilterV2Selection(setAttributeTypeExpandClose);
    const disabledAttributeTypes: string[] = screenFilterConfig?.disabledAttributeTypes ?? [];

    return (
        <div>
            {!hideGlobalTimeFilterComponent && (
                <div className="px-4 py-3 border-b border-filterV2Border">
                    <div className="font-xs font-medium leading-[21px] text-filterV2TextPrimary mb-2">Time Period</div>
                    <FilterV2Chip label={timeSelectionLabel?.toUpperCase()} />
                </div>
            )}
            {Object.keys(allCheckedAttribute).map((attributeType) => {
                const selectedNames = Object.keys(allCheckedAttribute[attributeType] || {});
                if (!selectedNames.length) return null;
                const isAttributeDisabled = disabledAttributeTypes?.includes(_.snakeCase(attributeType));
                const label = uppercaseFilterLabels
                    ? formatWord(attributeType).toUpperCase()
                    : formatWord(attributeType);
                return (
                    <div className="px-4 py-3 border-b border-filterV2Border" key={attributeType}>
                        <div className="flex justify-between items-center mb-2">
                            <span className="font-xs font-medium leading-[21px] text-filterV2TextPrimary">{label}</span>
                            <span
                                role="button"
                                className={`font-xxs font-medium leading-[18px] text-filterV2Primary ${
                                    isAttributeDisabled ? 'pointer-events-none' : 'cursor-pointer'
                                }`}
                                onClick={() => {
                                    if (isAttributeDisabled) return;
                                    clearAttributeType(attributeType);
                                }}
                            >
                                Clear All
                            </span>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {selectedNames.map((attributeName: string) => (
                                <FilterV2Chip
                                    key={attributeName}
                                    label={attributeName}
                                    onRemove={
                                        isAttributeDisabled
                                            ? undefined
                                            : () => removeAttributeValue(attributeType, attributeName)
                                    }
                                />
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default FilterV2AppliedFilters;
